import { createSlice } from "@reduxjs/toolkit";

export const bannerSlice = createSlice({
  name: "banner",
  initialState: {
    list: [],
    campus_list: [],
    job_list: [],
  },
  reducers: {
    setBanner: (state, action) => {
      console.log("setBanner", action.payload);
      state.list = action.payload.list;
    },
    setCampusBanner: (state, action) => {
      console.log("setCampusBanner", action.payload);
      state.campus_list = action.payload.list;
    },
    setJobBanner: (state, action) => {
      console.log("setJobBanner", action.payload);
      state.job_list = action.payload.list;
    },
  },
});

export const { setBanner, setCampusBanner, setJobBanner } = bannerSlice.actions;

export default bannerSlice.reducer;
